import RegistryGiftTrackerPage from 'src/routes/(registry)/registry/gift-tracker/Route'

const GiftTrackerPageById = () => <RegistryGiftTrackerPage />

export default GiftTrackerPageById
